<template>
  <div class="card pointer">
    <div class="card-content" :class="gerar_qrcode ? 'blur' : ''" @click="gerar_qrcode = true">
      <div class="avatar">
        <span class="avatar-ini"><i class="fas fa-qrcode"></i></span>
      </div>
      <div class="info">
        <p class="nome">Gerar Novo QR Code</p>
        <span class="subtitulo">Após gerado, o antigo QR Code não será mais válido.</span>
      </div>
    </div>

    <div class="card-back" :class="(gerar_qrcode ? 'show' : '')">
      <el-button @click="gerarQRcode" :loading="gerando_qrcode" icon="el-icon-check" class="botao">
        <span>Confirmar</span>
      </el-button>
      <el-button icon="el-icon-close" class="botao-cancelar ml-5" @click.stop="gerar_qrcode = false">
        <span>Cancelar</span>
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GerarQRcode',
  props: {
    abrirDialog: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    gerar_qrcode: false,
    gerando_qrcode: false
  }),
  methods: {
    gerarQRcode() {
      this.gerando_qrcode = true;
      this.abrirDialog.aberto = true;

      this.$confirm('Deseja gerar um novo QR Code?', 'Gerar QR Code', {
        confirmButtonText: 'Gerar QR Code',
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'botao',
        cancelButtonClass: 'botao-cancelar',
        type: 'info',
        center: true,
        beforeClose: async (action, instance, done) => {
          if (action === 'confirm') {
            // eslint-disable-next-line
            instance.confirmButtonLoading = true;

            const ref = this.$db.ref('qrcode');
            ref.remove(() => {
              ref.push({
                key: true
              });
            });

            // eslint-disable-next-line
            instance.confirmButtonLoading = false;
            done();
          } else done();
        }
      }).then(() => {
        this.$message.success('QR Code gerado com sucesso.');
        this.gerar_qrcode = false;
        this.gerando_qrcode = false;
        this.abrirDialog.aberto = false;
      }).catch(() => {
        this.gerar_qrcode = false;
        this.gerando_qrcode = false;
        this.abrirDialog.aberto = false;
      });
    }
  }
};
</script>
